import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import Navbar from "../../layout/Navbar"
import Footer from "../../layout/Footer"
import SEO from "../../components/SEO"
import Icon from "@mdi/react"
import { mdiHome, mdiCar, mdiArrowLeft } from "@mdi/js"
import car404 from "../../assets/cars/404car.webp"
import "./notFound.scss"

const NotFound = () => {
  const navigate = useNavigate()
  const [countdown, setCountdown] = useState(5)

  useEffect(() => {
    // Countdown timer
    const countdownInterval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    // Redirect after 5 seconds
    const redirectTimer = setTimeout(() => {
      navigate("/")
    }, 5000)

    // Cleanup timers on unmount
    return () => {
      clearInterval(countdownInterval)
      clearTimeout(redirectTimer)
    }
  }, [navigate])

  return (
    <div className="notFound">
      <SEO 
        title="404 - Page Not Found"
        description="The page you are looking for does not exist. Return to Pulpit Cab homepage or explore our services."
        keywords="404, page not found, Pulpit Cab"
        noindex
      />
      <Navbar />
      <div className="notFound__container">
        <div className="notFound__content">
          {/* Animated 404 Number */}
          <div className="notFound__number">
            <span className="notFound__digit">4</span>
            <span className="notFound__digit notFound__digit--animated">0</span>
            <span className="notFound__digit">4</span>
          </div>

          {/* Main Message */}
          <h1 className="notFound__title">Oops! Page Not Found</h1>
          <p className="notFound__description">
            The page you're looking for seems to have taken a wrong turn. 
            Don't worry, we'll help you get back on track!
          </p>
          <p className="notFound__redirect-message">
            Redirecting to homepage in {countdown} second{countdown !== 1 ? 's' : ''}...
          </p>

          {/* Illustration/Icon */}
          <div className="notFound__illustration">
            <div className="notFound__car">
              <img
                src={car404}
                alt="Pulpit Cab car illustration"
                className="notFound__car-img"
              />
            </div>
            <div className="notFound__road">
              <div className="notFound__road-line"></div>
              <div className="notFound__road-line"></div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="notFound__actions">
            <button
              className="notFound__button notFound__button--primary"
              onClick={() => navigate("/")}
            >
              <Icon path={mdiHome} size={1.5} />
              Go to Homepage
            </button>
            <button
              className="notFound__button notFound__button--secondary"
              onClick={() => navigate("/cabs")}
            >
              <Icon path={mdiCar} size={1.5} />
              Book a Cab
            </button>
            <button
              className="notFound__button notFound__button--outline"
              onClick={() => navigate(-1)}
            >
              <Icon path={mdiArrowLeft} size={1.5} />
              Go Back
            </button>
          </div>

          {/* Quick Links */}
          <div className="notFound__quickLinks">
            <p className="notFound__quickLinks-title">Popular Pages:</p>
            <div className="notFound__quickLinks-list">
              <a href="/" className="notFound__link">Book Cab</a>
              <a href="/about-us" className="notFound__link">About Us</a>
              <a href="/blogs" className="notFound__link">Blogs</a>
              <a href="/partner" className="notFound__link">Partner</a>
              <a href="/corporate" className="notFound__link">Corporate</a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default NotFound

